import '../scss/product-page-style.scss';
import ProductPage from './pages/product/index';

document.addEventListener('DOMContentLoaded', () => {
  ProductPage.init();
});